import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=ad541f66&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=ad541f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad541f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad541f66')) {
      api.createRecord('ad541f66', component.options)
    } else {
      api.reload('ad541f66', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=ad541f66&scoped=true&", function () {
      api.rerender('ad541f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y4WXRjo6y6H0/JS/comp/SearchFilterTokens.vue"
export default component.exports